import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  question: '¿En qué formato recibo el material?',
  answer: 'Todos los recursos se entregan en PDF de alta calidad. Puedes imprimirlos, proyectarlos o utilizarlos desde una computadora, tableta o teléfono.'
}, {
  question: '¿Qué estoy comprando exactamente?',
  answer: 'Accedes a la Biblioteca Química Visual: fichas visuales, actividades en versiones A y B, evaluaciones, juegos e historietas científicas listos para imprimir y usar. Además, recibes sin costo adicional los 5 cuadernillos visuales de apoyo.'
}, {
  question: '¿Sirve para docentes de toda Latinoamérica?',
  answer: 'Sí. El material trabaja los contenidos fundamentales de Química de educación secundaria. Cada docente puede seleccionar, organizar y adaptar los recursos según el programa de su país o institución.'
}, {
  question: '¿Cómo recibiré el acceso?',
  answer: 'Una vez confirmado el pago, recibirás el acceso al material digital en el correo electrónico que indiques al momento de la compra.'
}, {
  question: '¿El pago es una suscripción?',
  answer: 'No. Es un pago único, sin suscripción ni renovaciones. Accedes al material y puedes volver a utilizarlo en los siguientes ciclos escolares.'
}, {
  question: '¿El precio está en dólares?',
  answer: 'El precio está expresado en dólares estadounidenses. Antes de confirmar tu compra, el checkout mostrará la conversión automática a tu moneda local según tu país y el medio de pago disponible.'
}, {
  question: '¿Puedo utilizarlo en mis clases particulares o talleres?',
  answer: 'Sí. Puedes utilizarlo en instituciones educativas, clases particulares, espacios de apoyo y talleres de ciencias. El material no puede revenderse, compartirse públicamente ni distribuirse como producto propio.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 md:py-16 px-4 bg-chem-ice" data-id="element-45" data-mp="2kvwzgjc5dt5g">
      <div className="max-w-3xl mx-auto" data-id="element-46" data-mp="2kuc5ovxnqe8n">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-chem-navy mb-6 md:mb-10" data-id="element-47" data-mp="2fwtut002xoy0">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-3" data-id="element-48" data-mp="33mely66dzsid">
          {faqs.map((faq, index) => <motion.div key={faq.question} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-2xl border border-chem-petrol/12 overflow-hidden shadow-sm" data-id="element-49" data-mp="33kbmkvjcgn0z" data-mpi={index}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} className="w-full p-5 md:p-6 text-left flex justify-between items-center gap-4" data-id="element-50" data-mp="1j5i6jddasmve">
                <span className="font-black text-chem-navy text-sm md:text-lg leading-tight" data-id="element-51" data-mp="7pgtlyg1g41a">
                  {faq.question}
                </span>
                <div className="shrink-0 text-chem-petrol" data-id="element-52" data-mp="chi5vkd7hurb">
                  {openIndex === index ? <MinusIcon size={20} data-id="element-53" data-mp="heqo1kyctysk" /> : <PlusIcon size={20} data-id="element-54" data-mp="md1x3tgts59q" />}
                </div>
              </button>
              <AnimatePresence data-id="element-55" data-mp="qgrfu2atjsmu">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-56" data-mp="vfb5odsj9okh">
                    <div className="px-5 md:px-6 pb-6 text-chem-navy/70 font-medium text-xs md:text-base leading-relaxed" data-id="element-57" data-mp="21vgasah9gfnf">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}